import React from "react";

export type CalculatorFormulaType = "managed" | "guided";

export interface CalculatorContextProps {
  value: number;
  changeValue: (value: number) => void;
  formula: CalculatorFormulaType;
  changeFormula: (formula: CalculatorFormulaType) => void;
}

export const CalculatorContext = React.createContext<CalculatorContextProps>({
  value: 0,
  changeValue: () => {},
  formula: "managed",
  changeFormula: () => {},
});
